import { Table, TableThProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import { forwardRef } from 'react';
import { RegistryModel, Row, SORT_DIRECTIONS } from 'shared/lib';

export type RegistryTableThSorterProps = TableThProps & {
	field: string;
};

export const createRegistryTableThSorter = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryTableThSorter = forwardRef<HTMLTableCellElement, RegistryTableThSorterProps>(
		({ field, className, children, ...props }, ref) => {
			const [activeField, direction, click] = useUnit([
				model.sortField.$value,
				model.sortDirection.$value,
				model.sorterClicked,
			]);

			const directionIcon = direction === SORT_DIRECTIONS.ASC ? <ChevronUp /> : <ChevronDown />;

			const icon = field === activeField ? directionIcon : <ChevronsUpDown />;

			return (
				<Table.Th
					ref={ref}
					data-test-id='registry-table-th-sorter'
					className={clsx('registry-table-th-sorter', className)}
					onClick={() => click(field)}
					{...props}
				>
					<span className='registry-table-th-sorter-wrapper'>
						{children}
						{icon}
					</span>
				</Table.Th>
			);
		},
	);

	return RegistryTableThSorter;
};
